export default __webpack_public_path__ + "static/media/reset-icon.1f6a0caa.svg";